import { Flex } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Form } from "formik";
import React, { ComponentProps } from "react";
import styled from "styled-components";

interface IProps extends ComponentProps<typeof Form> {
  loading?: boolean;
}

export const CommonForm: React.FC<IProps> = ({
  loading,
  children,
  ...formProps
}) => {
  return (
    <Form
      {...formProps}
      style={{ display: "flex", flexDirection: "column", position: "relative" }}
    >
      {children}
      {loading ? <LoadingOverlay /> : null}
    </Form>
  );
};

const LoadingOverlay: React.FC = () => {
  return (
    <Wrapper justify="center" align="center">
      <LoadingSpinner />
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.75);
  width: 100%;
  height: 100%;
`;
